import { OptionItem } from '@/contracts/models/survey';

/**
 * Short, survey-scoped stable id used as an option's `value`. Decouples an
 * option's display text (any length, freely editable) from its logic key, so
 * generated branching `visibleIf` expressions stay bounded and rules stay
 * bound when the text is renamed. 6 chars from an unambiguous alphabet is
 * ample uniqueness within a single survey's option set.
 */
const ALPHABET = '23456789abcdefghijkmnpqrstuvwxyz';
const ID_LENGTH = 6;

export function createOptionId(): string {
  const bytes = new Uint8Array(ID_LENGTH);
  crypto.getRandomValues(bytes);
  let id = '';
  for (let i = 0; i < ID_LENGTH; i++) {
    id += ALPHABET[bytes[i] % ALPHABET.length];
  }
  return id;
}

/** A fresh blank option with a generated stable id. */
export function createOption(text = ''): OptionItem {
  return { value: createOptionId(), text };
}
